var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inputglya",class:_vm.inputsize},[_c('v-text-field',{class:_vm.myclass,attrs:{"type":_vm.type,"label":_vm.label,"placeholder":_vm.place || _vm.label,"solo":_vm.solo,"outlined":_vm.outlined,"filled":_vm.filled,"value":_vm.value,"required":"","error-messages":_vm.nameErrors,"prefix":_vm.prefix},on:{"input":_vm.updateValue}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }